import React, { useEffect } from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

export const PrivacyPolicyPage = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen font-['Inter',sans-serif]">
      <Header />
      
      {/* Content */}
      <main className="pt-32 pb-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12">
            {/* Title */}
            <h1 className="text-3xl sm:text-4xl font-bold text-[#013C5D] mb-8 text-center">
              Aviso de Privacidad
            </h1>

            {/* Intro */}
            <div className="prose prose-lg max-w-none text-gray-600">
              <p className="mb-6 leading-relaxed">
                <strong>Etérea Business, S.A.P.I. de C.V., S.O.F.O.M., E.N.R.</strong>, (en adelante ETÉREA BUSINESS) empresa legalmente constituida de conformidad con las Leyes Mexicanas, con domicilio legal para oír y recibir todo tipo de notificaciones el ubicado en calle con domicilio en <strong>Boulevard Manuel Gómez Morín #8016, Local 7, Col. Sandra Lucia, C.P 32530 Ciudad Juárez, Chihuahua, México</strong>, emite el presente aviso en atención a la Ley Federal de Protección de Datos Personales en posesión de Particulares y su Reglamento, así como los Lineamientos del Aviso de Privacidad emitidos por la Secretaría de Economía (en adelante la LEY, el REGLAMENTO y los LINEAMIENTOS respectivamente) y demás normatividad aplicable.
              </p>
              <p className="mb-8 leading-relaxed">
                ETÉREA BUSINESS hace constar la responsabilidad frente al tratamiento de datos personales observando los principios de licitud, consentimiento, información, calidad, lealtad, proporcionalidad y responsabilidad previstos en la LEY.
              </p>

              {/* Section: Datos sometidos */}
              <h2 className="text-2xl font-bold text-[#013C5D] mt-10 mb-4">
                DATOS SOMETIDOS A TRATAMIENTO Y SUS FINALIDADES
              </h2>
              <p className="mb-4 leading-relaxed">
                El presente aviso de privacidad lo emite ETÉREA BUSINESS en su rol de Responsable, el cual va dirigido a los clientes de los servicios que se brindan, por lo que la información que les sea requerida se utilizará para:
              </p>

              {/* Finalidades originarias */}
              <h3 className="text-xl font-semibold text-[#013C5D] mt-6 mb-3">
                a) Finalidades originarias y necesarias para la prestación del servicio.
              </h3>
              <ol className="list-decimal list-inside space-y-2 mb-6 ml-4">
                <li>Identificación del solicitante y/o cliente, según sea el caso.</li>
                <li>Integración del expediente de información de nuestro cliente.</li>
                <li>Gestión, control, administración y procesamiento de la solicitud de crédito y, en su caso, el otorgamiento de este.</li>
                <li>Gestión, control, administración, ejecución y cumplimiento del contrato de crédito celebrado con el cliente conforme a la solicitud correspondiente.</li>
                <li>Gestión, control y administración de la cobranza administrativa (a través de cualquier medio de contacto otorgado en la solicitud), extrajudicial y, en su caso, judicial derivada de los servicios proporcionados por ETÉREA BUSINESS.</li>
                <li>Investigación de cambios en el perfil transaccional del cliente.</li>
                <li>Cumplimiento a obligaciones de carácter fiscal o comercial.</li>
                <li>Atención de consultas, dudas, aclaraciones o quejas del cliente.</li>
                <li>Estadística y registro histórico de usuarios y clientes.</li>
                <li>Creación, mantenimiento y entrenamiento de los modelos de riesgo predictivos de ETÉREA BUSINESS.</li>
                <li>Mantener la seguridad de la información y de la operación.</li>
                <li>Protección ante casos de robo de identidad.</li>
              </ol>

              {/* Finalidades secundarias */}
              <h3 className="text-xl font-semibold text-[#013C5D] mt-6 mb-3">
                b) Finalidades secundarias.
              </h3>
              <ol className="list-decimal list-inside space-y-2 mb-6 ml-4">
                <li>Fines mercadotécnicos, publicitarios y/o de prospección comercial.</li>
                <li>Otorgamiento de estímulos o reconocimientos a clientes, cuando participen en nuestras campañas publicitarias, mercadológicas o comerciales.</li>
                <li>Uso de imágenes y testimonios de clientes y/o usuarios para fines publicitarios y de ofertas comerciales referentes a productos y/o servicios ofrecidos o relacionados con productos y/o servicios contratados.</li>
                <li>Mejoras en el servicio de atención y trato con el cliente.</li>
              </ol>

              <p className="mb-8 p-4 bg-[#CFA935]/10 rounded-lg border-l-4 border-[#CFA935]">
                Recuerda que puedes solicitar la revocación de tu consentimiento en cualquier momento. Dicha solicitud aplica desde el momento en que envías el formulario debidamente llenado. La negativa para el uso de tus datos personales para estas finalidades no será motivo para negar el servicio.
              </p>

              {/* Medios para limitar */}
              <h2 className="text-2xl font-bold text-[#013C5D] mt-10 mb-4">
                MEDIOS PARA LIMITAR EL USO O DIVULGACIÓN DE LOS DATOS
              </h2>
              <p className="mb-6 leading-relaxed">
                ETÉREA BUSINESS pone a su disposición medios para limitar el tratamiento de sus datos personales. En el supuesto de que considere que sus datos no fueron tratados conforme a la finalidad expresada por ETÉREA BUSINESS, usted podrá ejercer sus derechos de acceso, rectificación, cancelación y/u oposición (conocidos como derechos ARCO).
              </p>

              {/* Derechos ARCO */}
              <div className="space-y-6">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="text-lg font-semibold text-[#013C5D] mb-2">ACCESO</h3>
                  <p className="text-gray-600">
                    En todo momento usted tiene derecho a conocer con qué datos personales suyos cuenta ETÉREA BUSINESS, para qué son utilizados y las condiciones del uso que se le está dando, así como conocer el Aviso de Privacidad al que está sujeto el tratamiento de sus datos personales.
                  </p>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="text-lg font-semibold text-[#013C5D] mb-2">RECTIFICACIÓN</h3>
                  <p className="text-gray-600">
                    Es su derecho a solicitar la corrección de la información personal en caso de que esté desactualizada, sea inexacta o incompleta.
                  </p>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="text-lg font-semibold text-[#013C5D] mb-2">CANCELACIÓN</h3>
                  <p className="text-gray-600">
                    Tendrá en todo momento el derecho a cancelar (eliminar) tus datos personales, los cuales serán dados de baja de nuestros registros, sistemas o bases de datos, cuando consideres que los mismos no están siendo utilizados adecuadamente, conforme a los principios, deberes y obligaciones previstos en la normatividad o en caso de no querer que sigan siendo tratados.
                  </p>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="text-lg font-semibold text-[#013C5D] mb-2">OPOSICIÓN</h3>
                  <p className="text-gray-600">
                    Es su derecho, en todo momento y por causa legítima, oponerse para que cese el uso de sus datos personales para fines específicos.
                  </p>
                </div>
              </div>

              {/* Mecanismo ARCO */}
              <h2 className="text-2xl font-bold text-[#013C5D] mt-10 mb-4">
                MECANISMO PARA EJERCER LOS DERECHOS ARCO
              </h2>
              <p className="mb-6 leading-relaxed">
                Usted podrá en cualquier momento, ejercitar indistintamente los derechos ARCO, enviando un escrito libre al correo electrónico <a href="mailto:confiaresf@gmail.com" className="text-[#CFA935] hover:underline font-semibold">confiaresf@gmail.com</a> en el horario de lunes a viernes de 8:00 a 14:00 horas y de 15:00 a 18:00 horas, que contenga:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-6 ml-4">
                <li>Nombre del titular de los datos personales</li>
                <li>Correo electrónico al que haremos llegar la respuesta a su solicitud</li>
                <li>Identificación oficial</li>
                <li>Una breve descripción de los datos personales respecto de los que busca ejercer alguno de los derechos</li>
                <li>Cualquier otro dato que estime relevante</li>
              </ul>
              <p className="mb-6 leading-relaxed">
                De conformidad con lo establecido en el artículo 29 de la Ley Federal de Protección de datos Personales en Posesión de Particulares. ETÉREA BUSINESS, como Responsable del tratamiento de sus datos personales, recibirá la solicitud de los titulares, entendiéndose estos como los clientes directos de ETÉREA BUSINESS, mismos que podrán sujetarse al Procedimiento para la Gestión de Derechos ARCO.
              </p>

              {/* Transferencia */}
              <h2 className="text-2xl font-bold text-[#013C5D] mt-10 mb-4">
                TRANSFERENCIA DE DATOS PERSONALES
              </h2>
              <p className="mb-6 leading-relaxed">
                ETÉREA BUSINESS le informa que <strong>no compartirá la información que brinde con terceros</strong> por lo que será de uso exclusivo e interno de ETÉREA BUSINESS.
              </p>

              {/* Cambios al aviso */}
              <h2 className="text-2xl font-bold text-[#013C5D] mt-10 mb-4">
                CAMBIOS AL AVISO DE PRIVACIDAD
              </h2>
              <p className="mb-6 leading-relaxed">
                En caso de existir una modificación al presente aviso de privacidad, ETÉREA BUSINESS se compromete a comunicárselo ya sea de forma personal, electrónicamente o por cualquier otro medio.
              </p>

              {/* Footer del documento */}
              <div className="mt-12 pt-8 border-t border-gray-200 text-center text-gray-500">
                <p className="text-sm">
                  Última actualización: Enero 2026
                </p>
                <p className="text-sm mt-2">
                  Contacto: <a href="mailto:confiaresf@gmail.com" className="text-[#CFA935] hover:underline">confiaresf@gmail.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
